/*global kakao*/
import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Context as StreetContext } from "../../context/StreetContext";
import { Button } from "primereact/button";

let map = null;

const imageSrc = "/images/pin.png", // 마커이미지의 주소입니다
  imageSize = new kakao.maps.Size(51, 74), // 마커이미지의 크기입니다
  imageOption = { offset: new kakao.maps.Point(26, 74) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

// 마커 이미지 & 기본 위치
const markerImage = new kakao.maps.MarkerImage(
  imageSrc,
  imageSize,
  imageOption
);

// Show map and pins
const Map = () => {
  let history = useHistory();

  const { state, getPhotos } = useContext(StreetContext);

  const options = {
    //지도를 생성할 때 필요한 기본 옵션
    center: new kakao.maps.LatLng(37.565626, 126.978001), //지도의 중심좌표.
    level: 4, //지도의 레벨(확대, 축소 정도)
  };

  const loadMap = () => {
    console.log("load map");
    //지도를 담을 영역의 DOM 레퍼런스
    const container = document.getElementById("map");
    //지도 생성 및 객체 리턴
    if (map === null) {
      map = new kakao.maps.Map(container, options);
    } else {
      map = null;
      map = new kakao.maps.Map(container, options);
    }

    // make a marker with state.location
    if (state.location) {
      const markerPosition = new kakao.maps.LatLng(
        state.location.lat,
        state.location.lng
      );

      const marker = new kakao.maps.Marker({
        position: markerPosition,
        image: markerImage,
      });

      marker.setMap(map);
      map.setCenter(markerPosition);
    }
  };

  const addMarkers = () => {
    if (state.photos) {
      state.photos.forEach((photo) => {
        console.log("Photo : ", photo.streetName);
        const markerPosition = new kakao.maps.LatLng(
          photo.location.lat,
          photo.location.lng
        );

        const marker = new kakao.maps.Marker({
          position: markerPosition,
          image: markerImage,
          map: map,
        });
      });
    }
  };

  useEffect(() => {
    getPhotos();
    loadMap();
  }, []);

  useEffect(() => {
    // console.log("state has been changed");
    if (state.photos) {
      // console.log("photos :", state.photos);
      addMarkers();
    }
  }, [state]);

  return (
    <div id="main">
      <div
        className="p-grid p-align-center vertical-container"
        style={{ backgroundColor: "#111d3d", height: "50px" }}
      >
        <div className="p-col-4" style={{ color: "white" }}>
          <Button
            icon="pi pi-chevron-left"
            className="p-text-text p-button-sm "
            style={{
              width: "120px",
              height: "30px",
              backgroundColor: "#111d3d",
              borderColor: "#111d3d",
            }}
            onClick={() => {
              history.goBack();
            }}
          >
            뒤로가기
          </Button>
        </div>
        <div
          className="p-col-4"
          style={{ color: "white", verticalAlign: "center" }}
        >
          노담 지도
        </div>
        <div className="p-col-4"></div>
      </div>
      <div
        id="map"
        style={{
          height: "80vh",
          width: "100%",
        }}
      ></div>
    </div>
  );
};

export default Map;
